import { styled, useTheme, Theme } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import MainCard from './ui-component/cards/MainCard';
import SkeletonEarningCard from './ui-component/cards/Skeleton/EarningCard';

interface TotalItemCardProps {
  isLoading: boolean;
  title: string;
  withAdornment: boolean;
  children: JSX.Element;
};

const CardWrapper = styled(MainCard)(({ theme, visible }: { theme: Theme, visible: boolean }) => ({
  backgroundColor: visible ? "rgb(0, 183, 0)" : "transparent",
  color: '#fff',
  overflow: 'hidden',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 210,
    height: 210,
    background: visible ? "rgb(0, 183, 0)" : "transparent",
    borderRadius: '50%',
    top: -85,
    right: -95,
    [theme.breakpoints.down('sm')]: {
      top: -105,
      right: -140
    }
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    width: 210,
    height: 210,
    background: visible ? "rgb(0, 183, 0)" : "transparent",
    borderRadius: '50%',
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down('sm')]: {
      top: -155,
      right: -70
    }
  }
}));

const TotalItemCard = ({ isLoading, title, withAdornment, children }: TotalItemCardProps) => {
  const theme = useTheme();
  return (
    <>
      {isLoading ? (
        <SkeletonEarningCard />
      ) : (
        // @ts-ignore
        <CardWrapper
          border={false}
          content={false}
          visible={withAdornment}
          theme={theme}
          className="!tw-min-w-0 !tw-overflow-hidden !tw-rounded-xl !tw-border-0 tw-shadow-none dark:!tw-bg-slate-900"
        >
          <Box
            className={withAdornment ? "tw-bg-gtr-teal" : "tw-bg-slate-50 dark:tw-bg-slate-900"}
            bgcolor={withAdornment ? "#006C77" : theme.palette.mode === "dark" ? "#111827" : "#f9fafb"}
            sx={{ minHeight: withAdornment ? 230 : { xs: 360, sm: 380 }, display: "flex", flexDirection: "column", height: "100%", borderRadius: 3 }}
          >
            
            {!withAdornment && <Grid item className="tw-px-3 tw-pt-4" style={{ justifyContent: "center", zIndex: 1, padding: "16px 12px 0px", textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 600,
                  color: "#006C77",
                  fontFamily: "Prometo",
                }}
              >
                {`Total ${title}`}
              </Typography>
            </Grid>}
            
            <Grid container direction="column" style={{ flex: 1, justifyContent: "center", position: "relative" }}>
              {withAdornment && <Grid item style={{ marginTop: "15px", justifyContent: "center", zIndex: 2, textAlign: "center" }}>
                <Typography
                  sx={{
                    fontSize: '18px',
                    fontWeight: 700,
                    fontFamily: "Prometo",
                    color: "#ffff"
                  }}
                >
                  {`Total ${title}`}
                </Typography>
              </Grid>}
              
              <Box sx={{ width: "100%", flex: 1, display: "flex", justifyContent: "center", alignItems: "center", pb: 2, pt: 1 }}>
                {children}
              </Box>
            </Grid>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

export default TotalItemCard;
